// extracted by mini-css-extract-plugin
export var blue = "_1w-h";
export var brand = "_1w-d";
export var darkGrey = "_1w-g";
export var disabled = "_1w-6";
export var disabledSubtle = "_1w-7";
export var error = "_1w-8";
export var green = "_1w-i";
export var grey = "_1w-f";
export var icon = "_1w-0";
export var inherit = "_1w-c";
export var lightGrey = "_1w-e";
export var orange = "_1w-k";
export var pink = "_1w-m";
export var primary = "_1w-1";
export var purple = "_1w-n";
export var quaternary = "_1w-4";
export var quinary = "_1w-5";
export var red = "_1w-l";
export var secondary = "_1w-2";
export var success = "_1w-b";
export var tertiary = "_1w-3";
export var warning = "_1w-9";
export var warningSecondary = "_1w-a";
export var white = "_1w-o";
export var yellow = "_1w-j";